import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';

const ContactsTable = Loadable(lazy(() => import('pages/contacts/contactsTable')));
const ContactProfile = Loadable(lazy(() => import('pages/contacts/contact')));
const CompaniesTable = Loadable(lazy(() => import('pages/contacts/companiesTable')));
const CarSourcingContactsTable = Loadable(lazy(() => import('pages/contacts/carSourcingContactsTable')));
const CompanyProfile = Loadable(lazy(() => import('pages/contacts/company')));
const TabCompany = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompany')));
const TabCompanyAnalytics = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyAnalytics')));
const TabCompanyContacts = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyContacts')));

// ==============================|| APPS ROUTING ||============================== //

const ContactsRoutes = {
  path: '/',
  element: (
    <ContactsProvider>
      <Outlet />
    </ContactsProvider>
  ),
  children: [
    {
      path: '/companies',
      element: <CompaniesTable />
    },
    {
      path: '/companies/:id',
      element: <CompanyProfile />,
      children: [
        {
          path: '',
          element: <Navigate to="details" />
        },
        {
          path: 'details',
          element: <TabCompany />
        },
        {
          path: 'contacts',
          element: <TabCompanyContacts />
        },
        {
          path: 'analytics',
          element: <TabCompanyAnalytics />
        }
      ]
    },
    {
      path: '/contacts',
      element: <ContactsTable />
    },
    {
      path: '/contacts/:id',
      element: <ContactProfile />
    },
    {
      path: '/carsourcing',
      element: <CarSourcingContactsTable />
    }
  ]
};

export default ContactsRoutes;
